export enum AgreementType {
  USER_AGREEMENT = 'USER_AGREEMENT',
  HORIZONCARES_PROGRAM_GUIDELINES = 'HORIZONCARES_PROGRAM_GUIDELINES',
  HORIZON_ECMONARCH_TERMS_CONDITIONS = 'HORIZON_ECMONARCH_TERMS_CONDITIONS',
  EAGLE_COPAY_ASSISTANCE_PROGRAM = 'EAGLE_COPAY_ASSISTANCE_PROGRAM',
  ALMIRALL_SEYSARA_TERMS_CONDITIONS = 'ALMIRALL_SEYSARA_TERMS_CONDITIONS',
  USER_PHARMACY_OWNER = 'USER_PHARMACY_OWNER',
}
